import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import useUniqueId from '../../util/useUniqueId.js';
import { Box } from '../Box/Box.js';
import { BaseButton as Button } from '../Button/Button.js';
import '../NotificationBadge/index.js';
import { ScreenReaderOnly } from '../ScreenReaderOnly/ScreenReaderOnly.js';
import { NotificationBadge as NotificationBadgeMemoized } from '../NotificationBadge/NotificationBadge.js';

var _excluded = ["variant", "notification", "notificationSrOnlyText", "size", "position", "top", "bottom", "left", "right", "zIndex"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FloatingButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
    notification = _ref.notification,
    notificationSrOnlyText = _ref.notificationSrOnlyText,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size,
    position = _ref.position,
    top = _ref.top,
    bottom = _ref.bottom,
    left = _ref.left,
    right = _ref.right,
    zIndex = _ref.zIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  var notificationSrOnlyTextId = useUniqueId();
  var notificationBadge = React.useMemo(function () {
    if (!notification || variant !== 'icon') return null;
    var offset = size === 'l' ? '4px' : '2px';
    return /*#__PURE__*/React.createElement(Box, {
      position: "absolute",
      top: offset,
      end: offset
    }, /*#__PURE__*/React.createElement(NotificationBadgeMemoized, {
      size: "s"
    }));
  }, [notification, size, variant]);
  var getButton = React.useCallback(function (_ref2) {
    var notificationSrOnlyTextIdProp = _ref2.notificationSrOnlyTextId,
      buttonPositionProps = _ref2.buttonPositionProps;
    return /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
      variant: variant,
      size: size,
      floating: true,
      ref: ref
    }, notificationSrOnlyTextIdProp ? {
      'aria-describedby': notificationSrOnlyTextIdProp
    } : undefined, buttonPositionProps));
  }, [ref, rest, size, variant]);
  var positionProps = {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    zIndex: zIndex
  };
  return notificationBadge ? /*#__PURE__*/React.createElement(Box, _extends({
    position: position || 'relative'
  }, positionProps), getButton({
    notificationSrOnlyTextId: notificationSrOnlyTextId
  }), notificationBadge, notificationSrOnlyText && /*#__PURE__*/React.createElement(ScreenReaderOnly, {
    id: notificationSrOnlyTextId
  }, notificationSrOnlyText)) : getButton({
    buttonPositionProps: _objectSpread(_objectSpread({}, positionProps), {}, {
      position: position
    })
  });
});
FloatingButton.defaultProps = {
  hierarchy: 'primary',
  size: 'l'
};
var FloatingButtonMemoized = /*#__PURE__*/React.memo(FloatingButton);
FloatingButtonMemoized.displayName = 'FloatingButton';

export { FloatingButtonMemoized as FloatingButton };
//# sourceMappingURL=FloatingButton.js.map
